<section class="main-section-help-standard-ipos">
  <div id="standardIposComp">
    <div class="main_section_headers" id="standardMainSecHeader">
      <span i18n="@@ipos-help.side-nav-non-custom-ipos-heading">Non-Custom IPOS</span>
    </div>
    <div class="ipos-help-standard-ipos-body" id="iposHelpStandard">
      <div id="standarIposInfoMainDiv">
        <div id="standarIposInfoChildDiv">
          <span i18n="@@ipos-help.side-nav-non-custom-ipos-sub-text-out-of-box-features-of-ipos">Non-Custom IPOS includes all the out-of-the-box features of IPOS
            with no worries about branding the experience. It reduces the multiple steps of adding Store Logo and other
            content groups, with a few clicks you get a running IPOS.</span>
        </div>
        <div class="ipos-help-standard-ipos-desc" id="iposHelpStandardDesc">
          <div id="standardIposIntelAdminMsg1">
            <span i18n="@@ipos-help.side-nav-non-custom-ipos-package-windows-gaming-linux-devices">You can download a Non-Custom IPOS package for
              Windows*, Windows* Gaming and Linux* devices.</span>
          </div>
          <div class="ipos-help-standard-ipos-desc" id="standardIposIntelAdminMsg2">
            <span i18n="@@ipos-help.standard-ipos-intel-admin-msg">Please follow the steps below:</span>
            <ol>
              <li>
                <span i18n="@@ipos-help.standard-ipos-package-initate-steps">Select a Package to initiate the
                  download.</span>
                <ul class="retail-hq-tab-feature-list">
                  <li>
                    <span i18n="@@ipos-help.side-nav-non-custom-ipos-mainstream-option-will-initiate"><strong>Mainstream:</strong>
                      This option will initiate the download of a Non-Custom IPOS package for Windows*.</span>
                  </li>
                  <li>
                    <span i18n="@@ipos-help.side-nav-non-custom-ipos-uwp-for-windows-and-windows-s-mode"><strong>UWP for Windows*:</strong> This
                      option will initiate the download of Non-Custom IPOS for devices with Windows* 10 in S Mode and
                      Windows* 11 in S Mode.</span>
                  </li>
                  <li>
                    <span i18n="@@ipos-help.standard-ipos-uwp-for-gaming-option"><strong>Gaming:</strong> To all users following message
                      ‘Please contact your Intel Representative for more game demos’ will be shown and they can connect with Intel 
                  representative for more game demos.</span>
                  </li>
                  <div
                  *ngIf="loginUserRole === 'retailHQUser' || loginUserRole === 'regionalHQ' || loginUserRole === 'storeUser'">
                  <img class="ipos-help-download-standard-new-package" alt="download package">
                </div>
                <div
                  *ngIf="!(loginUserRole === 'retailHQUser' || loginUserRole === 'regionalHQ' || loginUserRole === 'storeUser')" id="iposHelpStandardNewPkg">
                  <img class="ipos-help-standard-new-package-unconnected" alt="download package">
                </div>
                  <li>
                    <span i18n="@@ipos-help.standard-ipos-creator-option"><strong>Creator:</strong> This option will
                      initiate the download of Non-Custom Creator IPOS package which includes creator-centric content,
                      GRFX and Nero Demo for Windows*.</span>
                  </li>
                  <li>
                    <span i18n="@@ipos-help.standard-ipos-linux-option"><strong>Linux*ISO:</strong> This option will
                      initiate the download of Non-Custom IPOS packages for devices with Linux* or devices with no
                      operating systems.</span>
                  </li>
                  <li>
                    <span i18n="@@ipos-help.standard-ipos-linux-ipos-option"><strong>Linux* IPOS Application Only:</strong> This option will
                      initiate the download of Non-Custom IPOS packages for devices running Ubuntu Desktop.</span>
                  </li>
                  <li>
                    <span i18n="@@ipos-help.standard-ipos-linux-ipos-option-packages-for-device-with-chromebook"><strong>Chromebook*:</strong> This option will
                      initiate the download of Non-Custom IPOS package for devices with Chromebook* operating
                      system.</span>
                  </li>
                </ul>
                <ol>
                  <li>
                  <span i18n="@@ipos-help.side-nav-non-custom-ipos-click-the-download-package-downloading-non-custom-ipos-package">Click the<strong> Download Package</strong> button to start downloading
                  the Non-Custom IPOS package.</span>
                  <div id="installationPkgNote">
                    <span i18n="@@ipos-help.installation-package.heading.note-label"><strong>Note</strong>:</span>
                      <div id="retailHQTabFeaturList">
                          <ul class="retail-hq-tab-feature-list">
                              <li>
                                <span i18n="@@ipos-help.standard-download-package-note-desc1">For connected users, instead of Download, ‘Generate’
                                  will be displayed if the package is not generated yet.</span>
                              </li>
                              <li>
                                <span i18n="@@ipos-help.standard-download-package-note-desc2">For unconnected users, Download will be displayed. (Please refer to the above screenshot)</span>
                              </li>
                          </ul>
                      </div>
                  </div>
                  <span i18n="@@ipos-help.side-nav-non-custom-ipos-for-linux-you-can-download-and-linux-iso">For Linux* you can download a Non-Custom IPOS package for <strong>Linux* ISO</strong> or <strong>Linux* IPOS Application Only</strong>.</span> 
                 </li>
                <div
                *ngIf="loginUserRole === 'retailHQUser' || loginUserRole === 'regionalHQ' || loginUserRole === 'storeUser' || loginUserRole === 'intelAdmin'" id="standardNewPkgIposHelp">
                <img class="ipos-help-generate-standard-new-package" alt="download package">
              </div>
              <div
                *ngIf="!(loginUserRole === 'retailHQUser' || loginUserRole === 'regionalHQ' || loginUserRole === 'storeUser' || loginUserRole === 'intelAdmin')" id="standardNewPkgUnconnected">
                <img class="ipos-help-standard-new-package-unconnected" alt="download package">
              </div>
                  <li>
                <span i18n="@@ipos-help.side-nav-non-custom-ipos-simple-interfact-to-get-everything-installation-process">Click the downloaded Non-Custom IPOS package (.exe file)
                  and start the installer. IPOS includes a simple interface to get everything up and running with just a few clicks.
                  Please view the <a class="btn-link" (click)="navigate()">Installation Process</a> for more information.</span>
                </li>
                </ol>
              <div
              *ngIf="loginUserRole === 'retailHQUser' || loginUserRole === 'regionalHQ' || loginUserRole === 'storeUser'" id="standardPkgDiv">
              <img class="ipos-help-download-standard-package" alt="download package">
            </div>
            <div
              *ngIf="!(loginUserRole === 'retailHQUser' || loginUserRole === 'regionalHQ' || loginUserRole === 'storeUser')" id="stdPkgUnconnectedDiv">
              <img class="ipos-help-standard-package-unconnected" alt="download package">
            </div>            
              <!-- <img class="ipos-help-language-popup" alt="language popup"/> 
            <li>
              <span  i18n="@@ipos-help.standard-language-popup">A language selection pop-up screen will display</span>
              <span class="mt-4" i18n="@@ipos-help.standard-language-for-installation">Select the language of your Standard IPOS Installation Package and click the <strong>Download Package</strong> button to start downloading the Standard IPOS package.</span>
            </li> -->     
            <div class="note-spacing" *ngIf="loginUserRole === 'retailHQUser' || loginUserRole === 'storeUser' || loginUserRole === 'intelAdmin' || loginUserRole === 'regionalHQ'" id="standardIposNote"><span i18n="@@ipos-help.standard-ipos-note"><strong>Note</strong></span>:
                <ul class="retail-hq-tab-feature-list">
                  <li><span i18n="@@ipos-help.side-nav-non-custom-ipos-able-to-download-it-without-having-to-generate-it">When a connected user generates a Non-Custom package, all other users
                    of same Retail HQ will be able to download it without having to generate it.</span></li>
                  <li><span i18n="@@ipos-help.side-nav-non-custom-ipos-unconnected-users-able-to-download-it-without-having-to-generate-it">When connected user generates a Non-Custom package, all other unconnected
                    users will be able to download it without generating it.</span></li>
                  <li i18n="@@ipos-help.standard-ipos-same-retail-config">Whenever there is a change in retailer configuration and if a package is generated or in download state, it will be automatically regenerated. Hence, the user will always have access to the updated package when the retailer configuration is updated.</li>
                </ul>
              </div>
            </ol>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>